/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
enum TimeCardLockedReason {
  unlocked = 0,
  Exported = 1,
  TimePeriodExported = 2,
  SpecMasterQueueClosingRelease = 4,
  TimesheetLocked = 8,
  TimePeriodLocked = 16,
}

export default TimeCardLockedReason;
